<template>
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    :fill="clr"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9333 6.3091L14.0667 3.21982L13.4444 2.61066L10.9333 5.06904L9.66667 3.82897L9.04445 4.45988L10.9333 6.3091ZM0 14.7938V13.0533H10.6667V14.7938H0ZM11.5556 8.70221C10.3259 8.70221 9.27778 8.27798 8.41111 7.42951C7.54444 6.58104 7.11111 5.55491 7.11111 4.3511C7.11111 3.1473 7.54444 2.12116 8.41111 1.2727C9.27778 0.424233 10.3259 0 11.5556 0C12.7852 0 13.8333 0.424233 14.7 1.2727C15.5667 2.12116 16 3.1473 16 4.3511C16 5.55491 15.5667 6.58104 14.7 7.42951C13.8333 8.27798 12.7852 8.70221 11.5556 8.70221ZM0 7.83199V6.09155H5.6C5.7037 6.41063 5.82222 6.7152 5.95556 7.00528C6.08889 7.29535 6.25185 7.57092 6.44444 7.83199H0ZM0 11.3129V9.57243H8.35556C8.6963 9.77548 9.05926 9.9459 9.44444 10.0837C9.82963 10.2215 10.237 10.3194 10.6667 10.3774V11.3129H0Z"
      :fill="clr"
    />
  </svg>
</template>

<script>
export default {
  props: ["clr"]
};
</script>

<style lang="scss" scoped></style>
